module.exports = __webpack_public_path__ + "static/media/meroha-web.d320de83.png";